function makeDirective(attrName, tester) {
	return {
		restrict: 'A',
		link: function ($scope, elem, attrs) {
			const commentNode = document.createComment('');
			attrs.$observe(attrName, newVal => {
				if (tester.call(tester, newVal)) {
					// should show
					if (commentNode.parentNode) {
						commentNode.parentNode.insertBefore(elem[0], commentNode);
					}
				} else if (elem[0].parentNode) {
					// should not show
					elem[0].parentNode.insertBefore(commentNode, elem[0]);
					elem.remove();
				}
			});
		},
	};
}

export function ifRole(Identity) {
	'ngInject';
	return makeDirective('shIfRole', role => {
		return Identity.role() == role;
	});
}

export function ifExecutive(Identity) {
	'ngInject';
	return makeDirective('shIfExecutive', () => Identity.isExecutive());
}

export function ifSuperadmin(Identity) {
	'ngInject';
	return makeDirective('shIfSuperadmin', () => Identity.isSuperadmin());
}

export function ifPermitted(Identity) {
	'ngInject';
	return makeDirective('shIfPermitted', permission => {
		return Identity.can(permission);
	});
}

export function ifLoggedin(Identity) {
	'ngInject';
	return makeDirective('shIfLoggedIn', () => Identity.isLoggedin());
}

export function ifLoggedout(Identity) {
	'ngInject';
	return makeDirective('shIfLoggedOut', () => Identity.isLoggedout());
}
